import * as yup from "yup";
import type { Asserts } from "yup";

import { DeliveryMethod } from "../constants";

const recipientSchema = yup.object({
  name: yup.string().optional(),
  email: yup.string().optional(),
  phone: yup.string().optional(),
});

const addressSchema = yup.object({
  countryCode: yup.string().required(),
  country: yup.string().required(),
  city: yup.string().required(),
  street: yup.string().required(),
  streetNumber: yup.string().optional(),
  flatNo: yup.string().optional(),
  zip: yup.string().required(),
});

const lockerSchema = yup.object({
  locker: yup.string().required(),
  lockerId: yup.string().required(),
  countryCode: yup.string().required(),
  country: yup.string().required(),
});

const prefillDataSchema = yup.object({
  id: yup.string().required(),
  recipient: recipientSchema.required(),
  locker: lockerSchema.default(undefined),
  address: addressSchema.default(undefined),
  deliveryMethod: yup.string().oneOf(Object.values(DeliveryMethod)).default(undefined),
});

type TPrefillSchema = Asserts<typeof prefillDataSchema>;

export type TPrefillData = Partial<TPrefillSchema>;

const validatePrefillData = (data: any): TPrefillData => prefillDataSchema.validateSync(data);

export default validatePrefillData;
